import React from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Grid,
  Chip,
  CircularProgress
} from "@mui/material";
import { useFetchBullMQQueues } from "./hooks/useFetchBullMQQueues";

const QueueDashboard = ({ onQueueSelect, selectedQueue }) => {
  const { data, isLoading, error } = useFetchBullMQQueues();

  if (isLoading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="200px">
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Box p={2}>
        <Typography color="error">Error loading queue data: {error.message}</Typography>
      </Box>
    );
  }

  const queues = data?.queues || [];

  const getStatusColor = (queue) => {
    if (queue.isPaused) { return "warning"; }
    if (queue.failed > 0) { return "error"; }
    if (queue.active > 0) { return "info"; }
    return "success";
  };

  return (
    <Box>
      <Typography variant="h5" gutterBottom>
        Queue Status Dashboard
      </Typography>
      <Grid container spacing={2}>
        {queues.map((queue) => (
          <Grid item xs={12} sm={6} md={4} key={queue.name}>
            <Card
              sx={{
                cursor: "pointer",
                border: selectedQueue === queue.name ? 2 : 0,
                borderColor: "primary.main",
                "&:hover": {
                  elevation: 4
                }
              }}
              onClick={() => onQueueSelect(queue.name)}
            >
              <CardContent>
                <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
                  <Typography variant="h6" component="div">
                    {queue.name}
                  </Typography>
                  <Chip
                    label={queue.isPaused ? "Paused" : "Active"}
                    color={getStatusColor(queue)}
                    size="small"
                  />
                </Box>

                <Grid container spacing={1}>
                  <Grid item xs={6}>
                    <Typography variant="body2" color="text.secondary">
                      Waiting: {queue.waiting}
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography variant="body2" color="text.secondary">
                      Active: {queue.active}
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography variant="body2" color="text.secondary">
                      Completed: {queue.completed}
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography variant="body2" color="text.secondary">
                      Failed: {queue.failed}
                    </Typography>
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default QueueDashboard;
